import { useMutation } from "@tanstack/react-query";
import { DELETE_GOAL } from "api/dataProviderTypes";
import fetchApi from "api/fetchApi";
import { ApiResponseData } from "api/types";
import { IReturnType } from "hooks/types";
import { SnackbarSeverity } from "hooks/useSnackbar";
import IGoal from "models/Goal";

type Props = {
  callback?: () => void;
  id: string;
  showSnackbar?: (message: string, severity: SnackbarSeverity) => void;
};

const useDeleteGoalMutation = ({ callback, id, showSnackbar }: Props) => {
  const {
    mutate,
    isLoading,
    isError,
    isSuccess,
    isFetching,
    refetch,
  }: IReturnType<ApiResponseData<IGoal>> = useMutation(
    [DELETE_GOAL],
    (id: string) => fetchApi(`kpis`).delete(`/${id}`),
    {
      onSuccess: () => {
        showSnackbar && showSnackbar("Goal Deleted Successfully", "success");
        callback && callback();
      },
      onError: (error) => {
        showSnackbar("Failed to Delete Goal", "error");
      },
    }
  );

  return { isLoading, isError, isFetching, isSuccess, mutate, refetch };
};

export default useDeleteGoalMutation;
